import listViewStore from 'owa-mail-list-store/lib/store/Store';
export default function selectConversationById(conversationId) {
    return listViewStore.conversationItems.get(conversationId);
}
//# sourceMappingURL=selectConversationById.js.map